module.exports = __webpack_public_path__ + "img/215.904ea90e.jpg";